import { render, staticRenderFns } from "./Pix.vue?vue&type=template&id=5a97e180&scoped=true"
import script from "./Pix.vue?vue&type=script&lang=js"
export * from "./Pix.vue?vue&type=script&lang=js"
import style0 from "./Pix.vue?vue&type=style&index=0&id=5a97e180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97e180",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PaymentProgressPaymentPix: require('/home/luiz/Sistemas/loja/components/Payment/ProgressPaymentPix.vue').default})
